module.exports = __webpack_public_path__ + "static/media/track-kleine-jongen.a23a60ca.png";